import React, { useEffect, useState, useRef, useCallback } from "react";
import "../css/paysuccess.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
// import { successPay } from "../apis/SuccessAPI";
import { PixelWithEvent } from "./common/PixelWithEvent ";
import * as FacebookAPI from "../apis/FacebookAPI";
import { sendMessage } from "../apis/SendMessageAPI";
import { sendEmailToClient } from "../apis/SendEmail";
import { BASE_URL, LIST_URL } from "../constans/ApiEndpointConstants";
import * as GetPixelAPI from "../apis/GetPixelAPI";
import { getOrder } from "../apis/GetOrder";
import { update_purchase_status } from "../apis/UpPurchaseStatus";
import { getDetails } from "../apis/GetDetails";
import { getFullDonationUrl, parseDonationUrl } from "../utils/urlUtils";
import Cookie from "react-cookies";
import LocalStorageUtil from "../utils/localStorageUtil";

const PaySuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ad = LocalStorageUtil.getAd() || "donation";
  // eslint-disable-next-line no-unused-vars
  const [orderDetails, setOrderDetails] = useState(null);
  const [shareCount, setShareCount] = useState(0);
  const [progress, setProgress] = useState(0);
  const [msgHidden, setMsgHidden] = useState(true);
  const [returnMsg, setReturnMsg] = useState("");
  // 使用 useRef 防止在 StrictMode 下重复调用 successcallback
  const hasProcessedPurchase = useRef(false);
  const orderNo = searchParams.get("clientNo");
  const stateParam = searchParams.get("state");
  const emailOrderNumber = searchParams.get("orderNo");
  const redirectStatus = searchParams.get("redirect_status");
  const isRedirectSucceeded =
    (redirectStatus === null || redirectStatus === "succeeded") &&
    stateParam !== "0";
  let email = searchParams.get("email") || "";
  let phone = searchParams.get("phone") || "";
  const [campaignDetails, setCampaignDetails] = useState(null);
  const emailSentKey = `successEmailSent_${orderNo}`;
  const [successPixelData, setSuccessPixelData] = useState();
  const detailPathParam = searchParams.get("detailPath") || null;
  const detailPathDecoded = detailPathParam
    ? decodeURIComponent(detailPathParam)
    : null;
  // 用于解析 id 的纯路径（去掉 detailPath 中的 query 部分，避免 id 带上 ?email=...）
  const detailPathForId = detailPathDecoded
    ? detailPathDecoded.split("?")[0]
    : null;
  const detailId =
    searchParams.get("detailId") ||
    (detailPathForId ? parseDonationUrl(detailPathForId) : "") ||
    "";

  // 如果 detailPath 中包含嵌入的查询参数（例如 "/donationDetails/test_17?email=...?phone=..."）
  // 则从中解析 email 和 phone（仅当它们未在 top-level query 中提供时覆盖）
  if (detailPathDecoded) {
    const qIndex = detailPathDecoded.indexOf("?");
    if (qIndex !== -1) {
      const queryString = detailPathDecoded.slice(qIndex + 1);
      // 支持用 ? 或 & 分隔的非标准或标准格式
      queryString.split(/[?&]/).forEach((pair) => {
        if (!pair) return;
        const [rawKey, rawVal] = pair.split("=");
        if (!rawKey || rawVal === undefined) return;
        const key = decodeURIComponent(rawKey).toLowerCase();
        const val = decodeURIComponent(rawVal);
        if (!email && key === "email") {
          email = val;
        }
        if (!phone && key === "phone") {
          phone = val;
        }
      });
    }
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    // 检查 state 参数，如果是 0 则跳转到失败页面
    if (stateParam === "0") {
      navigate("/payfial");
    }
  }, [stateParam, navigate]);

  // 分享功能
  const campaignUrl = campaignDetails
    ? getFullDonationUrl(campaignDetails, BASE_URL)
    : detailPathDecoded
    ? `${BASE_URL.replace(/\/$/, "")}${
        detailPathDecoded.startsWith("/") ? "" : "/"
      }${detailPathDecoded}`
    : `${BASE_URL.replace(/\/$/, "")}/donationDetails/${detailId}`;
  const campaignUrlWithAd = `${campaignUrl}?ad=share`;

  // 分享文案：优先使用 detailsData.share_text（如果存在），否则回退到默认文案
  const defaultShareText =
    "Hello! I’d like to share an important cause that is currently accepting support. Donations of any amount help move this effort forward, and sharing this message is another great way to help. Thank you for your time and consideration.";

  const invitationTextRaw = campaignDetails?.share_text || defaultShareText;

  // 将常见的智能引号替换为普通引号，避免 URL 编码后显示异常
  const invitationText = invitationTextRaw
    .replace(/'/g, "'") // 替换右单引号
    .replace(/'/g, "'") // 替换左单引号
    .replace(/"/g, '"') // 替换左双引号
    .replace(/"/g, '"'); // 替换右双引号
  const encodedCampaignUrl = encodeURIComponent(campaignUrlWithAd);
  const encodedInvitation = encodeURIComponent(
    `${invitationText}\n\n${campaignUrlWithAd}`
  );

  // 系统邮箱
  const emailSubject = encodeURIComponent("Join me in supporting this cause");
  const emailMailtoUrl = `mailto:?subject=${emailSubject}&body=${encodedInvitation}`;
  // Gmail
  const emailGmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&su=${emailSubject}&body=${encodedInvitation}`;

  // Outlook
  const emailOutlookUrl = `https://outlook.live.com/mail/deeplink/compose?subject=${emailSubject}&body=${encodedInvitation}`;

  // Yahoo
  const emailYahooUrl = `https://compose.mail.yahoo.com/?subject=${emailSubject}&body=${encodedInvitation}`;

  const shareOptions = [
    {
      id: "facebook",
      name: "Facebook",
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ),
      color: "#1877F2",
      url: `https://www.facebook.com/dialog/share?app_id=407682420960&display=popup&href=${encodedCampaignUrl}`,
    },
    {
      id: "whatsapp",
      name: "WhatsApp",
      icon: (
        <svg
          t="1763977259813"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="44607"
          width="200"
          height="200"
        >
          <path
            d="M512 1024C229.10781 1024-0.121905 794.819048 0 511.951238 0 229.180952 229.10781 0 512 0c282.770286 0 512 229.180952 512 511.951238C1024 794.794667 794.770286 1024 512 1024zM202.825143 827.367619l160.134095-41.203809a311.369143 311.369143 0 0 0 152.429714 39.740952c171.885714 0 311.734857-139.849143 311.734858-311.734857S687.299048 202.459429 515.413333 202.459429c-171.910095 0-311.759238 139.824762-311.759238 311.710476 0 55.832381 14.799238 110.177524 42.910476 157.939809L202.849524 827.367619z m168.326095-97.913905l-92.525714 23.79581 25.185524-89.404953-6.436572-9.99619a257.901714 257.901714 0 0 1-40.862476-139.678476c0-142.726095 116.126476-258.82819 258.876952-258.828191 142.726095 0 258.852571 116.102095 258.852572 258.828191S658.115048 773.022476 515.413333 773.022476c-47.664762 0-94.232381-13.04381-134.704762-37.741714l-9.508571-5.851429z m56.661333-360.350476l-20.23619-1.121524a24.454095 24.454095 0 0 0-17.383619 5.948953c-9.825524 8.533333-25.502476 24.990476-30.305524 46.445714-7.192381 31.98781 3.900952 71.143619 32.646095 110.323809 28.720762 39.15581 82.261333 101.839238 176.932572 128.609524 30.47619 8.606476 54.491429 2.80381 73.020952-9.020952a65.29219 65.29219 0 0 0 28.40381-41.472l3.242666-15.09181a10.48381 10.48381 0 0 0-5.851428-11.702857l-68.388572-31.50019a10.48381 10.48381 0 0 0-12.678095 3.096381l-26.843428 34.791619a7.68 7.68 0 0 1-8.630858 2.584381c-18.383238-6.460952-79.969524-32.256-113.737142-97.328762a7.753143 7.753143 0 0 1 0.975238-8.630857l25.648762-29.671619a10.48381 10.48381 0 0 0 1.706666-10.971429l-29.476571-68.949333a10.48381 10.48381 0 0 0-9.045334-6.339048z"
            fill="#15D135"
            p-id="44608"
          ></path>
        </svg>
      ),
      color: "#25D366",
      url: `https://api.whatsapp.com/send?text=${encodedInvitation}`,
    },
    {
      id: "messenger",
      name: "Messenger",
      icon: (
        <img alt="" src={process.env.PUBLIC_URL + "/share/messager1.png"} />
      ),
      color: "#006AFF",
      url: `https://www.facebook.com/dialog/send?link=${encodedCampaignUrl}&app_id=407682420960&redirect_uri=${encodedCampaignUrl}`,
    },
    {
      id: "email",
      name: "Email",
      icon: <img alt="" src={process.env.PUBLIC_URL + "/share/email.png"} />,
      color: "#424242",
      url: emailGmailComposeUrl,
      // ✔ 桌面端优先 Gmail（Chrome）
      // ✔ iPhone Safari 不允许 Gmail → 自动 fallback 到 系统邮件
      // ✔ Android 既能打开 Gmail App，也能 fallback
      onClick: () => {
        const tryOpen = (url) =>
          window.open(url, "_blank", "noopener,noreferrer");

        // 1️⃣ Gmail
        if (tryOpen(emailGmailComposeUrl)) return;

        // 2️⃣ Outlook
        if (tryOpen(emailOutlookUrl)) return;

        // 3️⃣ YahooMail
        if (tryOpen(emailYahooUrl)) return;

        // 4️⃣ 系统 mailto
        window.location.href = emailMailtoUrl;
      },
      sameTab: false,
    },
    {
      id: "sms",
      name: "Sms",
      icon: (
        <svg viewBox="0 0 1024 1024" p-id={2744} width={60} height={60}>
          <path
            d="M761.984 1009.28H253.696C138.368 1009.28 44.8 915.712 44.8 800.384V292.096C44.8 176.768 138.368 83.2 253.696 83.2h508.288c115.328 0 208.896 93.568 208.896 208.896v508.288c0 115.328-93.568 208.896-208.896 208.896z"
            fill="#00E560"
            p-id={2745}
          />
          <path
            d="M507.776 265.856c-72.576 0-139.776 20.352-193.536 54.528-54.272 34.432-94.592 83.2-113.408 139.264-7.552 22.528-11.648 46.464-11.648 71.04 0 92.16 56.448 172.928 142.208 220.544 7.68 4.224 11.648 13.44 8.32 21.632-6.4 15.616-14.592 30.592-24.32 44.672-3.072 4.352 0.768 10.368 6.016 8.96 29.44-7.808 56.96-19.072 81.92-33.28 9.088-5.248 19.456-6.912 29.696-4.864 23.936 4.736 49.024 7.296 74.88 7.296 176 0 318.592-118.656 318.592-264.832 0-146.304-142.72-264.96-318.72-264.96z"
            fill="#FFFFFF"
            p-id={2746}
          />
        </svg>
      ),
      color: "#00E560",
      url: `sms:?body=${encodedInvitation}`,
      sameTab: true,
    },
    {
      id: "line",
      name: "Line",
      icon: (
        <svg
          t="1763973161718"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="16409"
          width="200"
          height="200"
        >
          <path
            d="M512 1024C229.2224 1024 0 794.7776 0 512 0 229.2224 229.2224 0 512 0c282.7776 0 512 229.2224 512 512 0 282.7776-229.2224 512-512 512z m-137.762133-286.378667V397.380267h-102.4V737.621333h102.4z m-51.2-488.448c-33.024 0-54.5792 22.954667-53.9136 53.589334-0.682667 29.218133 20.8896 52.872533 53.248 52.872533 33.672533 0 55.2448-23.6544 55.2448-52.8896-0.682667-30.6176-21.572267-53.572267-54.5792-53.572267z m133.410133 488.448h102.4V541.405867c0-9.728 1.365333-20.1728 4.061867-26.453334 6.724267-19.456 23.569067-39.645867 51.882666-39.645866 37.034667 0 51.882667 29.917867 51.882667 73.762133V737.621333h102.4V535.842133c0-100.181333-50.517333-146.1248-117.9136-146.1248-54.562133 0-88.251733 32.7168-101.7344 54.272h-2.030933l-4.7104-46.609066h-88.9344c1.348267 29.917867 2.696533 66.0992 2.696533 108.544V737.621333z"
            fill="#0073B1"
            p-id="16410"
          ></path>
        </svg>
      ),
      color: "#00C300",
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedCampaignUrl}`,
    },
    {
      id: "telegram",
      name: "Telegram",
      icon: (
        <img
          src={process.env.PUBLIC_URL + "/share/telegram.png"}
          alt="Telegram"
          width={60}
          height={60}
          loading="lazy"
        />
      ),
      color: "#0088cc",
      url: `https://telegram.me/share/url?url=${encodedCampaignUrl}&text=${encodeURIComponent(
        invitationText
      )}`,
    },

    {
      id: "x",
      name: "X",
      icon: (
        <svg
          t="1763974179807"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="32571"
          width="200"
          height="200"
        >
          <path
            d="M0 512a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z"
            fill="#000000"
            p-id="32572"
          ></path>
          <path
            d="M196.923077 196.923077m0 0l630.153846 0q0 0 0 0l0 630.153846q0 0 0 0l-630.153846 0q0 0 0 0l0-630.153846q0 0 0 0Z"
            fill="#FFFFFF"
            p-id="32573"
          ></path>
          <path
            d="M518.065231 461.981538L357.966769 237.883077H272.541538l198.340924 277.504 24.969846 34.894769 169.747692 237.764923h85.425231l-208.108308-291.209846-24.851692-34.894769z"
            fill="#000000"
            p-id="32574"
          ></path>
          <path
            d="M806.636308 177.230769H252.494769c-40.014769 0-75.264-0.630154-75.264 39.384616v630.153846c0 40.014769 117.523692 0 157.538462 0l304.64 25.993846c40.054154 0 207.36 14.020923 207.36-25.993846v-630.153846c0-40.014769-0.118154-39.384615-40.132923-39.384616zM639.409231 827.076923l-171.795693-244.696615L252.455385 827.076923H196.923077l246.035692-279.827692L196.923077 196.923077h187.667692l162.658462 231.660308L751.064615 196.923077h55.571693l-234.614154 266.870154L827.076923 827.076923h-187.667692z"
            fill="#000000"
            p-id="32575"
          ></path>
        </svg>
      ),
      color: "#000000",
      url: `https://twitter.com/intent/post?text=${encodedInvitation}&url=${encodedCampaignUrl}`,
    },
    {
      id: "nextdoor",
      name: "Nextdoor",
      icon: (
        <img
          alt=""
          src={process.env.PUBLIC_URL + "/share/nextdoor.png"}
          style={{ borderRadius: "50%" }}
        />
      ),
      color: "#7AD000",
      url: `https://nextdoor.com/share/?url=${encodedCampaignUrl}`,
    },
  ];

  // 随机生成六位字符（包含数字和字母）
  const generateRandomCode = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  };

  // 获取或生成 userid
  let userid = localStorage.getItem("userid");
  if (!userid) {
    userid = generateRandomCode();
    localStorage.setItem("userid", userid);
  }

  // 从 getpixel 接口获取模板 ID 等配置，然后调用fetchCampaignDetails方法获取像素等配置
  useEffect(() => {
    try {
      const strippedUrl = BASE_URL.replace(/^https?:\/\//, "");
      GetPixelAPI.getpixel(strippedUrl)
        .then((res) => {
          const pixelData = res?.data?.data || {};

          setSuccessPixelData(pixelData);

          // 获取 detailId：优先从 pixelData 中获取，如果没有则从 URL 参数获取
          const detailIdFromPixel = pixelData?.donationID;
          const detailIdFromUrl = searchParams.get("detailId");
          const finalDetailId = detailIdFromPixel || detailIdFromUrl;

          // 调用获取 campaign details 的方法
          if (finalDetailId) {
            fetchCampaignDetails(finalDetailId);
          }
        })
        .catch((error) => {
          console.error("Failed to fetch templateId from getpixel", error);
        });
    } catch (error) {
      console.error("Failed to init templateId from getpixel", error);
    }
  }, []);

  // 从 pixel 配置中提取成功邮件模板 ID
  const successEmailTemplateId = successPixelData?.successEmailId;

  //从接口获取orderDetails
  const getOrderRes = async () => {
    if (!orderNo) return;

    try {
      const res = await getOrder(orderNo);

      const order = res.data.data.data;
      const parsedOrder = JSON.parse(order);

      // 将 hasSentPurchase 从外层数据合并到 parsedOrder 中
      const hasSentPurchaseFromOuter =
        res.data.data?.hasSentPurchase ??
        res.data.data?.uphasSentPurchases ??
        0;
      const mergedOrder = {
        ...parsedOrder,
        hasSentPurchase: hasSentPurchaseFromOuter,
      };

      setOrderDetails(mergedOrder);

      if (isRedirectSucceeded) {
        successcallback(mergedOrder);

        // 只有在有 successEmailTemplateId 时才发送邮件
        if (successEmailTemplateId) {
          // 如果已经发送过成功邮件，则不再重复发送
          const alreadySent = localStorage.getItem(emailSentKey) === "true";

          if (!alreadySent) {
            try {
              await sendEmailToClient(
                successEmailTemplateId,
                "{name},{Ordernumber},{Amount}",
                `${parsedOrder.firstName} ${parsedOrder.lastName},${emailOrderNumber},${parsedOrder.amount}`,
                "{name}",
                `${parsedOrder.firstName} ${parsedOrder.lastName}`,
                email
              );

              sendMessage(
                `${BASE_URL}-[成功支付邮件发送成功]:id=${detailId}:ad=${ad}:userid=${userid}:email=${email}`
              );
              localStorage.setItem(emailSentKey, "true");
            } catch (err) {
              console.error("发送成功邮件失败:", err);
              sendMessage(
                `${BASE_URL}-[成功支付邮件发送失败]:id=${detailId}:${
                  err?.message || err
                }`
              );
            }
          }
        }
      }
    } catch (error) {
      console.error("获取订单信息失败:", error);
    }
  };

  // 处理支付成功回调（移除对 successEmailTemplateId 的依赖）
  useEffect(() => {
    // 使用 localStorage 跟踪是否已为当前订单发送过消息
    if (orderNo && isRedirectSucceeded) {
      const messageSentKey = `successPayMessageSent_${orderNo}`;
      const hasSentMessage = localStorage.getItem(messageSentKey);

      if (!hasSentMessage) {
        sendMessage(
          BASE_URL + `[ Success Pay]:id=${detailId}:ad=${ad}:userid=${userid}  `
        );
        // 标记已发送，避免刷新时重复发送
        localStorage.setItem(messageSentKey, "true");
      }

      getOrderRes();
    }
  }, [orderNo, isRedirectSucceeded]);

  // 当 campaignDetails 获取到后，如果之前跳过了 successcallback，现在重新执行
  useEffect(() => {
    if (campaignDetails && orderDetails && !hasProcessedPurchase.current) {
      // 检查是否已经处理过购买事件
      const flag = Cookie.load("purchased");
      if (!flag) {
        successcallback(orderDetails);
      }
    }
  }, [campaignDetails, orderDetails]);

  // 初始化分享进度
  useEffect(() => {
    const savedCount = localStorage.getItem("shareCount");
    const savedProgress = localStorage.getItem("progress");

    if (savedCount) {
      setShareCount(parseInt(savedCount, 10));
    }

    if (savedProgress) {
      const parsedProgress = parseInt(savedProgress, 10);
      setProgress(parsedProgress);

      // 如果 progress 已经是 100，则自动显示第三条 returnMsg
      if (parsedProgress === 100) {
        setReturnMsg(
          "Thank you for sharing! Your support helps this campaign reach more people and make an impact."
        );
      }
    }
  }, []);

  // facebookApi
  const successcallback = (orderDetail) => {
    // 防止在 StrictMode 下重复调用
    if (hasProcessedPurchase.current) {
      return;
    }

    // 当前订单号
    const currentOrderNo =
      orderNo || orderDetail?.clientNo || orderDetail?.orderNo || "";

    // 检查订单的 hasSentPurchase 状态（0=未发送，1=已发送）
    // 支持多个可能的字段名
    const hasSentPurchase = orderDetail?.hasSentPurchase ?? 0;

    // 每个订单唯一 event_id
    // Facebook 会根据 event_name + event_id 自动去重
    const event_id = `purchase_${currentOrderNo}`;

    // 如果 hasSentPurchase 为 0，才调用 Facebook Conversion API
    if (hasSentPurchase === 0) {
      // 检查 campaignDetails 是否已获取，如果没有则延迟执行（不标记已处理）
      if (!campaignDetails) {
        console.log("campaignDetails not ready, will retry later");
        return;
      }

      // 标记已执行（在确认 campaignDetails 准备好后再标记）
      hasProcessedPurchase.current = true;

      const eventData = {
        value: orderDetail.amount,
        content_ids: ["donation"],
        content_name: "Success Donation",
        content_type: "product",
        contents: [
          {
            id: "donation",
            title: "Donation",
            quantity: 1,
          },
        ],
        currency: "USD",
        num_items: 1,
      };

      let userdata = {
        em: orderDetail.email,
        ph: orderDetail.phone,
        fn: orderDetail.firstName,
        ln: orderDetail.lastName,
        ct: orderDetail.city,
        st: orderDetail.state,
        zp: orderDetail.zipCode,
        country: orderDetail.country,
      };

      PixelWithEvent("Purchase", event_id);
      PixelWithEvent("Donate", event_id);

      FacebookAPI.Facebook(
        campaignDetails?.fbq_token,
        campaignDetails?.pixel,
        event_id,
        "Purchase",
        eventData,
        userdata
      )
        .then((res) => {
          sendMessage(
            BASE_URL + `[Purchase]:id=${detailId}:ad=${ad}:userid=${userid}  `
          );

          sendMessage(
            `purchase eventsAll---${JSON.stringify(res)}:id=${detailId}`
          );
          localStorage.removeItem("orderDetail");
          // 更新订单的 hasSentPurchase 为 1
          update_purchase_status(currentOrderNo, 1).catch((err) => {
            console.error("更新 hasSentPurchase 失败:", err);
          });
        })
        .catch((err) => {
          console.error("Failed to send event", err);
          // 如果失败，重置标记以便重试
          hasProcessedPurchase.current = false;
        });

      FacebookAPI.Facebook(
        campaignDetails?.fbq_token,
        campaignDetails?.pixel,
        event_id,
        "Donate",
        eventData,
        userdata
      );
    } else {
      // hasSentPurchase 已经是 1，只清理 localStorage
      localStorage.removeItem("orderDetail");
    }
  };

  const backToProduct = () => {
    navigate("/");
  };

  const handleShareOptionClick = (option) => {
    if (!option.url) {
      return;
    }

    handleShareClick(option.name);

    if (option.sameTab) {
      window.location.href = option.url;
      return;
    }

    window.open(option.url, option.target || "_blank", "noopener,noreferrer");
  };

  // 处理分享操作
  const handleShareClick = (platformName = "") => {
    // 发送分享消息
    sendMessage(
      BASE_URL +
        `[Success Share]:id=${detailId}:ad=${ad}:userid=${userid}:platform=${platformName}  `
    );

    let newShareCount = shareCount + 1;
    let newProgress = progress;

    if (newShareCount !== 3 && newShareCount !== 5) {
      newProgress = Math.min(newProgress + 20, 100);
    }

    setShareCount(newShareCount);
    setProgress(newProgress);

    //将分享次数和进度条进度存在本地缓存
    localStorage.setItem("shareCount", newShareCount);

    // 延迟更新进度条
    setTimeout(() => {
      setProgress(newProgress);
      localStorage.setItem("progress", newProgress);
    }, 800); // 800ms 延迟更新进度条

    setMsgHidden(false);

    // 延迟显示不同的消息
    setTimeout(() => {
      if (newShareCount === 3) {
        setReturnMsg(
          "Share with another friend. Sharing with the same friend doesn't generate statistics."
        );
      } else if (newShareCount === 5) {
        setReturnMsg("Group conversations can also be shared.");
      } else if (newShareCount >= 7) {
        setReturnMsg(
          "Thank you for sharing! Your continued support helps this campaign reach more people and make a lasting impact."
        );
      } else {
        setReturnMsg("");
      }
    }, 800); // 800ms 延迟显示消息
  };

  // 给图片加上前缀
  const resolveUrl = (raw) => {
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
    return `${LIST_URL.replace(/\/$/, "")}/${String(raw).replace(/^\//, "")}`;
  };

  // 获取 campaignDetails 的方法，用于分享与成功页展示
  const fetchCampaignDetails = useCallback(async (id) => {
    if (!id) return;

    try {
      const res = await getDetails(id);
      // 后端返回结构可能为 res.data 或 res.data.data，尽量兼容
      const payload = res?.data;

      setCampaignDetails(payload);
    } catch (err) {
      console.error("Failed to fetch campaign details in SuccessPay:", err);
    }
  }, []);

  // 如果 URL 中携带 detailPath（编码后的 /donationDetails/Name_id），优先从中解析 id 并获取 campaignDetails
  useEffect(() => {
    const pidFromPath = detailPathForId
      ? parseDonationUrl(detailPathForId)
      : null;
    const pid = detailId || pidFromPath;
    if (pid && !campaignDetails) {
      fetchCampaignDetails(pid);
    }
  }, [detailId, detailPathForId, campaignDetails, fetchCampaignDetails]);

  return (
    <>
      {/* top */}
      <div className="product_box_top success_product_box_top">
        <div
          className="product_box_top_left"
          onClick={backToProduct}
          style={{ cursor: "pointer" }}
        >
          <svg
            t={1763633148216}
            className="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id={2746}
            width={200}
            height={200}
          >
            <path
              d="M297.813333 491.648l1.365334-1.749333 379.093333-376.149334a38.784 38.784 0 0 1 5.077333-4.096 34.346667 34.346667 0 0 1 14.293334-4.992c2.218667-0.170667 2.176-0.170667 4.394666-0.170666a33.493333 33.493333 0 0 1 14.549334 4.181333c12.330667 6.997333 18.688 21.76 15.274666 35.498667-1.237333 5.077333-7.04 13.44-7.04 13.44l-355.498666 352.853333 354.090666 354.389333s6.272 7.978667 7.893334 12.928a32.213333 32.213333 0 0 1-33.749334 41.557334c-6.656-0.682667-17.749333-7.68-17.749333-7.68l-379.221333-377.984-1.28-1.450667a30.378667 30.378667 0 0 1-7.893334-17.749333 31.018667 31.018667 0 0 1 3.712-18.602667 27.221333 27.221333 0 0 1 2.688-4.224z"
              p-id={2747}
            />
          </svg>
        </div>
        <div className="logo_container">
          <img
            src={process.env.PUBLIC_URL + "/head/ico-new.png"}
            alt="gyo"
            className="gyo_logo"
            style={{ height: "40px" }}
          />
        </div>
        <div className="tw-w-1/3" />
      </div>
      {/* main */}
      <div className="success_box">
        <img
          alt="Donation Successful"
          src={resolveUrl(
            campaignDetails?.image?.[0]?.url || orderDetails?.successLogo
          )}
          className="success_box_img"
        />
        <div className="success_box_txt1">
          Thank you for your donation.
          <br />
          Your contribution will make a meaningful difference.
          <br />
          You will receive a donation confirmation via email (
          <span className="success_box_txt1_span">{email}</span>) or SMS (
          <span className="success_box_txt1_span">{phone}</span>) shortly.
        </div>

        {/* Share Section */}
        <div className=" success_pay_share">
          {shareOptions.map((option) => (
            <button
              key={option.id}
              className="quick-share-modal__share-option"
              type="button"
              onClick={() => handleShareOptionClick(option)}
              aria-label={`Share via ${option.name}`}
            >
              <span
                className="quick-share-modal__share-icon"
                style={{ color: option.color }}
              >
                {option.icon}
              </span>
            </button>
          ))}
        </div>
        {progress > 0 && (
          <div className="quick-share-modal__progress-section quick-share-modal__progress-section-success">
            <div className="quick-share-modal__progress-header">
              <span>Share progress</span>
              <span>{progress}%</span>
            </div>

            <div className="quick-share-modal__progress-bar">
              <div
                className="quick-share-modal__progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>

            <p className="quick-share-modal__share-count">
              Shared {shareCount} times
            </p>
            {!msgHidden && returnMsg && (
              <p className="quick-share-modal__return-msg">{returnMsg}</p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default PaySuccess;
